
import { Badge } from '@/components/ui/badge';

type SkillsSelectionStepProps = {
  selectedSkills: string[];
  handleSkillToggle: (skill: string) => void;
};

const SkillsSelectionStep = ({ selectedSkills, handleSkillToggle }: SkillsSelectionStepProps) => {
  // All possible skills
  const allSkills = [
    'Project Management', 'Leadership', 'Communication', 'Problem Solving',
    'Technical Writing', 'UI/UX Design', 'Frontend Development', 'Backend Development',
    'DevOps', 'Data Analysis', 'Marketing', 'Sales', 'Customer Success',
    'Product Management', 'Research', 'Strategy', 'Finance', 'HR'
  ];
  
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-2">
        {allSkills.map((skill) => (
          <Badge 
            key={skill}
            variant={selectedSkills.includes(skill) ? "default" : "outline"}
            className="cursor-pointer py-2 px-3"
            onClick={() => handleSkillToggle(skill)}
          >
            {skill}
          </Badge>
        ))}
      </div>
      <p className="text-sm text-muted-foreground mt-4">
        Selected {selectedSkills.length} skills. You can update these later in your profile.
      </p>
    </div>
  );
};

export default SkillsSelectionStep;
